module.exports = __webpack_public_path__ + "img/redo.88aed0a6.svg";